import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import ConditionalRenderer from './conditional-renderer';

const FloatingWidget = styled.div`
  position: fixed;
  z-index: 9999999;
  bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left:0;
  margin:0;
`;

const WidgetWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const Button = styled.button`
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  background-color: #02BD7E !important;
  transition: all .5s ease-in-out;
  border-radius: 100px !important;
  padding: 10px 50px 10px 25px;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 16px;
  font-weight: inherit !important;
  text-decoration: none;
  position: relative;
  border: transparent !important;
  color: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer !important;
  }
`;

const CloseButton = styled.button`
  padding: 1px;
  border-radius: 100px;
  position: relative;
  opacity: .25;
  transition: all .5s ease-in-out;
  border: transparent;
  background: none;
  cursor:pointer;
  &:hover {
    opacity: 1;
  }
`;

const CloseIcon = styled.span`
  position: absolute;
  top: -10px;
  right: 12px;
  cursor: pointer !important;
`;

const ButtonTextWrapper = styled.span`
margin-left: 7px;
color: #ffffff !important;
`;

interface FloatingWidgetLoginButtonProps {
  clientId: string;
  buttonText: string;
};

const FloatingWidgetLoginButton: React.FC<FloatingWidgetLoginButtonProps> = (props) => {
  const redirectUrl = new URL(location.href);
  const [isRendered, setIsRendered] = useState(true);
  const closeWidget = useCallback(() => { setIsRendered(false); }, [isRendered]);

  const openLogin = () => {
    window.open(`https://auth.phone.email/log-in?client_id=${props.clientId}&redirect_url=${redirectUrl}&auth_type=2`, 'peLoginWindow', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=500, height=560, top=' + (screen.height - 600) / 2 + ', left=' + (screen.width - 500) / 2);
  };

  return (
    <ConditionalRenderer condition={isRendered}>
      <FloatingWidget>
        <WidgetWrapper>
          <Button onClick={openLogin}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="white" d="M19.95 21C17.8667 21 15.8083 20.5458 13.775 19.6375C11.7417 18.7292 9.89167 17.4417 8.225 15.775C6.55833 14.1083 5.27083 12.2583 4.3625 10.225C3.45417 8.19167 3 6.13333 3 4.05C3 3.75 3.1 3.5 3.3 3.3C3.5 3.1 3.75 3 4.05 3H8.1C8.33333 3 8.54167 3.07917 8.725 3.2375C8.90833 3.39583 9.01667 3.58333 9.05 3.8L9.7 7.3C9.73333 7.56667 9.725 7.79167 9.675 7.975C9.625 8.15833 9.53333 8.31667 9.4 8.45L6.975 10.9C7.30833 11.5167 7.70417 12.1125 8.1625 12.6875C8.62083 13.2625 9.125 13.8167 9.675 14.35C10.1917 14.8667 10.7333 15.3458 11.3 15.7875C11.8667 16.2292 12.4667 16.6333 13.1 17L15.45 14.65C15.6 14.5 15.7958 14.3875 16.0375 14.3125C16.2792 14.2375 16.5167 14.2167 16.75 14.25L20.2 14.95C20.4333 15.0167 20.625 15.1375 20.775 15.3125C20.925 15.4875 21 15.6833 21 15.9V19.95C21 20.25 20.9 20.5 20.7 20.7C20.5 20.9 20.25 21 19.95 21Z" />
            </svg>
            <ButtonTextWrapper>{props.buttonText}</ButtonTextWrapper>
          </Button>
          <CloseButton onClick={closeWidget}>
            <CloseIcon>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="#92E3A9" d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" />
              </svg>
            </CloseIcon>
          </CloseButton>
        </WidgetWrapper>
      </FloatingWidget>
    </ConditionalRenderer>
  );
};

export default FloatingWidgetLoginButton;
